module.exports = __webpack_public_path__ + "img/product_5.00ea3f20.png";